export default __webpack_public_path__ + "static/media/StPauls.60b7565f.jpeg";